import { LayoutDashboard, UsersIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

import { useHeadManager } from '@/lib/headManagerProvider'

import { Dashboard } from './components/dashboard'
import { Sidebar } from './components/sidebar'
import { Users } from './components/users'

export function Admin() {
  const { setTitle } = useHeadManager()
  const [activeTab, setActiveTab] = useState<'dashboard' | 'users'>('dashboard')

  useEffect(() => {
    setTitle('Admin')
  }, [setTitle])

  return (
    <div className="flex min-h-screen">
      <Sidebar
        items={[
          { label: 'Dashboard', icon: LayoutDashboard, value: 'dashboard' },
          { label: 'Usuários', icon: UsersIcon, value: 'users' },
        ]}
        onSelect={setActiveTab}
        activeTab={activeTab}
      />

      <main className="flex-1 p-6">
        {activeTab === 'dashboard' && <Dashboard />}{' '}
        {activeTab === 'users' && <Users />}{' '}
      </main>
    </div>
  )
}
